import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { BAND_ACTIONS, ITravelBlockPassengerParams } from "Bands/types";
import { TravelBlockPassengerService } from "Bands/services";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const dispatchGetTravelBlockPassengers = ({
  dispatch,
  blockId,
  page,
  isRecursive,
}: {
  dispatch: Dispatch<any>;
  blockId: string;
  page?: number;
  isRecursive?: boolean;
}) => {
  dispatch(
    getTravelBlockPassengers({
      blockId: blockId,
      paginationKey: API_ENDPOINTS.EVENT_TRAVEL_BLOCK(blockId),
      page: page || 1,
      isRecursive,
    })
  );
};

export const getTravelBlockPassengers = createAsyncThunk(
  BAND_ACTIONS.getTravelBlockPassengers,
  async (
    {
      blockId,
      page,
      isRecursive,
    }: {
      blockId: string;
      page: number;
      paginationKey: string;
      isRecursive?: boolean;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await TravelBlockPassengerService.getPassengers(
        {
          travelBlock: API_ENDPOINTS.EVENT_TRAVEL_BLOCK(blockId),
          page,
        },
        isRecursive
      );

      // keep the key even if response is empty
      return {
        [IDataKeys.eventTravelBlockPassenger]: data.eventTravelBlockPassenger,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTravelBlockPassenger = createAsyncThunk(
  BAND_ACTIONS.createTravelBlockPassenger,
  async (passenger: ITravelBlockPassengerParams, { rejectWithValue }) => {
    try {
      const data = await TravelBlockPassengerService.createPassenger(passenger);
      const id = Object.values(data?.eventTravelBlockPassenger)?.[0]?.attributes?.id;
      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editTravelBlockPassenger = createAsyncThunk(
  BAND_ACTIONS.editTravelBlockPassenger,
  async (props: { id: string; data: ITravelBlockPassengerParams }, { rejectWithValue }) => {
    try {
      const data = await TravelBlockPassengerService.editPassenger(props);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTravelBlockPassenger = createAsyncThunk(
  BAND_ACTIONS.deleteTravelBlockPassenger,
  async (id: string, { rejectWithValue }) => {
    try {
      await TravelBlockPassengerService.deletePassenger(id);
      return {
        path: API_ENDPOINTS.EVENT_TRAVEL_BLOCK_PASSENGER(id),
        dataKey: IDataKeys.eventTravelBlock,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
